
import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

import { defineComponent, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  Config,
  NetworkConfigService
} from '@/views/dashboard/group/client/terminal-info/network-config/network-config.service'
import FoldPanel from '@/views/dashboard/group/client/terminal-info/fold-panel/fold-panel.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'

export default defineComponent({
  components: { EmptyData, FoldPanel },
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },

  setup (props, context) {
    const injector = useReflectiveInjector([NetworkConfigService])
    const service = injector.get(NetworkConfigService)

    const compData = ref<Config[]>([])
    const isLoading = ref(false)

    function updateData () {
      isLoading.value = true
      service.getNetworkConfig({
        device_id: props.deviceId
      }).then(res => {
        compData.value = res.configs
      }).finally(() => {
        isLoading.value = false
      })
    }

    updateData()

    return {
      compData,
      isLoading,
      getSvgIconDataUrl,
    }
  }
})
